'use strict';

require('./curry.js');
require('./chunk-ba04ad2f.js');
require('./chunk-d7703e54.js');
var variadic = require('./variadic.js');
require('./_append.js');
require('./append.js');
require('./flip.js');
var __chunk_3 = require('./chunk-56a5551b.js');
require('./chunk-e6d921c6.js');
var __chunk_5 = require('./chunk-ac19a55d.js');

/**
 * Concatenates multiple lists into a single list.
 *
 * @function
 * @param {Array|String} as The lists to concatenate.
 * @returns {Array|String} A list that contains the concatenated elements in
 * the list of `as`.
 * @example
 *
 * import { concat } from 'fkit'
 * concat([1], [2, 3], [4, 5, 6]) // [1, 2, 3, 4, 5, 6]
 * concat('f', 'oo', 'bar') // 'foobar'
 */

var concat = variadic(function (as) {
  return __chunk_3.concatWith(__chunk_5.mempty(as), as);
});

module.exports = concat;
